"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import { Section, Typography } from "@/components/ui";
import { DayToDayFeature } from "@/lib/data/industryType";

interface DayToDayFeaturesProps {
  features: DayToDayFeature[];
  imgBaseUrl?: string;
  title: React.ReactNode | string;
  description?: React.ReactNode | string;
  extraContent?: React.ReactNode; // Optional extra content after description
}

export default function DayToDayFeatures({
  features,
  imgBaseUrl,
  title,
  description,
  extraContent,
}: DayToDayFeaturesProps) {
  const [isClient, setisClient] = useState(false);
  useEffect(() => {
    setisClient(true);
  }, []);

  return (
    <Section variant="default" background="transparent">
      <div className="flex flex-col lg:flex-row gap-8">
        <div className="w-full lg:w-4/12 lg:sticky text-center lg:text-left top-64 h-fit">
          <Typography variant="h2" as="h2" className="mb-5">
            {title}
          </Typography>
          {description && (
            <Typography variant="body" as="p">
              {description}
            </Typography>
          )}
          <div className="h-1 w-10 bg-primary rounded mt-5 mx-auto lg:mx-0" />
          {/* Conditional Extra Content */}
          {extraContent && <div className="mt-4 w-full">{extraContent}</div>}
        </div>

        <div className="w-full lg:w-8/12">
          <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="space-y-4">
                <div className="p-0 border h-full border-gray-200 rounded-lg overflow-clip hover:shadow-md">
                  <Image
                    src={imgBaseUrl ? imgBaseUrl + feature.imageUrl : feature.imageUrl}
                    alt={feature.imageAlt}
                    title={feature.imageAlt}
                    width={400}
                    height={300}
                    className="w-full"
                    quality={80}
                    priority={index === 0}
                    fetchPriority={index === 0 ? "high" : "auto"}
                  />
                  <div className="p-6 mb-5">
                    <Typography variant="h4" as="h3" className="mb-2">
                      {feature.title}
                    </Typography>

                    {typeof feature.description === "string" ? (
                      isClient ? (
                        <Typography variant="body" as="p">
                          <span dangerouslySetInnerHTML={{ __html: feature.description }} />
                        </Typography>
                      ) : (
                        <Typography variant="body" as="p">{feature.description}</Typography>
                      )
                    ) : (
                      <Typography variant="body" as="p">{feature.description}</Typography>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
}
